
<template>
  <div class="tableNode">
    <el-table
      :data="tableData"
      style="width: 100%;"
      :header-cell-style="setHeraderStyle"
      v-loading="loading"
      :span-method="objectSpanMethod"
      empty-text="No Data"
      v-if="!ticketMan"
    >
      <el-table-column
        v-for="(item,index) in columns"
        :prop="item.key"
        :label="item.title"
        :key="index"
        :width="item.width"
        show-overflow-tooltip
      >
        <template #default="{row}" v-if="item.key == 'broadcast_type'">
          {{row.broadcast_type | stateText(RoomType)}}
        </template>
        <!--:width="item.width"-->

      <template slot-scope="scope" v-else>
        <!-- 票号复制行 -->
        <slot v-if="item.key == 'exhticket_num'" name="exhticket_num" :exhticketNum="scope.row[item.key]"></slot>
        <!-- 操作按钮 -->
        <slot v-if="item.key == 'action'" name="action" :dataList="scope.row" :actionType="scope.row.sendcollect"></slot>
        <span >{{ scope.row[item.key] }}</span>
      </template>
      </el-table-column>
    </el-table>

    <el-table
        :data="tableData"
        class="ticket-manage"
        style="width: 100%;"
        :header-cell-style="setHeraderStyle"
        :span-method="objectSpanMethod"
        v-loading="loading"
        empty-text="还没有任何数据"
        border
        v-else
    >
      <el-table-column
          v-for="(item,index) in columns"
          :prop="item.key"
          :label="item.title"
          :key="index"
          :width="item.width"
          show-overflow-tooltip
      >
<!--        interview_status-->


        <template #default="{row}" v-if="item.key == 'broadcast_type'">
          {{row.broadcast_type | stateText(RoomType)}}
        </template>
        <!--:width="item.width"-->
        <!--所在城市-->
        <template slot-scope="scope" v-else-if="item.key == 'city'">
          <slot  name="city" :location="scope.row.location"></slot>
        </template>
        <template slot-scope="scope" v-else-if="item.key == 'email'">
          <slot  name="email" :row="scope.row"></slot>
        </template>
        <template slot-scope="scope" v-else-if="item.key == 'interview'">
          <slot  name="interview" :row="scope.row.interview_status"></slot>
        </template>
        <!--求职意向-->
        <template slot-scope="scope" v-else-if="item.key == 'jobThink'">
          <slot  name="jobThink" :jobThinkType="scope.row[item.key]"></slot>
        </template>

        <template slot-scope="scope" v-else>
          <!-- 票号复制行 -->
          <slot v-if="item.key == 'exhticket_num'" name="exhticket_num" :exhticketNum="scope.row[item.key]"></slot>
          <!-- 操作按钮 -->
          <slot v-if="item.key == 'action'" name="action" :dataList="scope.row" :actionType="scope.row.sendcollect"></slot><!-- 岗位 -->
        <slot v-if="item.key == 'jobList'" name="jobList" :jobList="scope.row" ></slot>
          <span >{{ scope.row[item.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>
<script>
  import {RoomType} from "../../../../common/constant/room";

  export default {
  props: {
    language: {
      type:Object,
      default:() => {}
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    mergeCol: {
      type: Number,
      default: () => {
        return -1;
      }
    },
    rowspan: {
      type: Number,
      default: () => {
        return 1;
      }
    },
    loading:{
      type:Boolean,
      default:true
    },
    ticketMan: {
      type:Boolean,
      default:false
    },
  },
  data() {
    return {
      RoomType: RoomType
    };
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if(this.mergeCol == columnIndex){
        return {
          rowspan: this.rowspan,
          colspan: 2
        };
      }
      /*if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }*/
    },
    //设置表头样式
    setHeraderStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return `background-color: #F2F2F2;
                        color: #424242;
                        padding:7.5px 0;
                        font-size:14px;
                        font-weight: normal;
                        `;
      }
    }
  }
};
</script>
<style>
  .infoPub .el-table .cell {
    padding-left: 5px;
  }
  .tableNode .el-table {
    color: #424242;
  }
.infoPub .tableNode {
  margin-top: 10px;
  padding: 20px 10px 68px 10px;
  background: #fff;
  /*height: 482px;*/
  box-sizing: border-box;
  overflow-y: auto;
}
.infoPub .tableNode .el-table__header th {
  border-top: 1px solid #e6e6e6 !important;
  border-bottom: 1px solid #e6e6e6 !important;
  padding: 0;
}
.infoPub .tableNode .el-table__header th .cell {
  height: 18px;
  line-height: 18px;
  padding-left: 10px;
}
.ticket-manage .has-gutter th {
  background: #f6f9ff !important;
  color: #313131 !important;
}
.ticket-manage tbody {
  color: #666666;
}
.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: hidden !important;
}
.ticket-manage table {
  width: 900px !important;
}
  .has-gutter th:nth-last-child(2) .cell {
    border-right: 0
  }



.infoPub .tableNode .el-table__row td {
  height: 50px;
  border-bottom: 1px solid #e6e6e6;
}


/*.infoPub .tableNode .el-table__row td .cell {*/
/*  padding-left: 19px;*/
/*}*/
/*.infoPub .tableNode .el-table--border::after,*/
/*.infoPub .tableNode .el-table--group::after,*/
/*.infoPub .tableNode .el-table::before {*/
/*  background-color: #a1a1a1;*/
/*}*/
/*  .el-table::before {*/
/*    bottom: inherit !important;*/
/*  }*/


</style>
